module.exports = __webpack_public_path__ + "static/media/office_management.c039462b.svg";